import materialGroupManagement from './material_group_management.vue';

export default materialGroupManagement;
